import { render } from "./Edit.vue?vue&type=template&id=2286395a"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render

export default script